export default __webpack_public_path__ + "static/logo-white-6769807adb66e554689e43dda2958e93.svg";